// Copyright (c) 2026 Watch Tower Bible and Tract Society of Pennsylvania
// All Rights Reserved. Proprietary and confidential.
// Unauthorized copying, modification, or distribution is strictly prohibited.
import { TableCell, TableRow } from './ui/table';
import { Button } from './ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import { Folder, MoreVertical, Pencil, Move, Trash2, Clock } from 'lucide-react';
import { formatDate } from '../lib/utils';

/**
 * Single folder row inside the Documents table.
 */
export default function FolderRow({
  folder,
  index,
  areaConfig,
  onOpen,
  onRename,
  onMove,
  onDelete,
  canWrite = true,
}) {
  return (
    <TableRow
      className="cursor-pointer hover:bg-slate-50/80 transition-colors animate-fade-in border-b border-slate-50"
      style={{ animationDelay: `${index * 0.03}s` }}
      onClick={() => onOpen(folder.id)}
      data-testid={`folder-row-${folder.id}`}
    >
      <TableCell className="font-medium py-4">
        <div className="flex items-center gap-3">
          <div className={`w-11 h-11 rounded-xl flex items-center justify-center ${areaConfig.bgColor} transition-transform hover:scale-105`}>
            <Folder className={`w-5 h-5 ${areaConfig.color}`} />
          </div>
          <span className="truncate max-w-[300px] text-slate-900">{folder.name}</span>
        </div>
      </TableCell>
      <TableCell className="text-slate-400 hidden sm:table-cell">—</TableCell>
      <TableCell className="text-slate-500 hidden md:table-cell">
        <div className="flex items-center gap-1.5 text-sm">
          <Clock className="w-3.5 h-3.5" />
          {formatDate(folder.created_at)}
        </div>
      </TableCell>
      <TableCell className="text-slate-500 text-sm hidden lg:table-cell">
        {folder.created_by_name}
      </TableCell>
      <TableCell>
        {canWrite && (
        <DropdownMenu>
          <DropdownMenuTrigger asChild onClick={(e) => e.stopPropagation()}>
            <Button
              variant="ghost"
              size="icon"
              className="rounded-xl hover:bg-slate-100"
              data-testid={`folder-menu-${folder.id}`}
            >
              <MoreVertical className="w-4 h-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="rounded-xl shadow-xl border-slate-200/80">
            <DropdownMenuItem
              onClick={(e) => { e.stopPropagation(); onRename(folder); }}
              className="py-2.5 cursor-pointer"
              data-testid={`rename-folder-${folder.id}`}
            >
              <Pencil className="w-4 h-4 mr-2" />
              Renomear
            </DropdownMenuItem>
            <DropdownMenuItem
              onClick={(e) => { e.stopPropagation(); onMove(folder); }}
              className="py-2.5 cursor-pointer"
              data-testid={`move-folder-${folder.id}`}
            >
              <Move className="w-4 h-4 mr-2" />
              Mover
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem
              onClick={(e) => { e.stopPropagation(); onDelete(folder); }}
              className="text-red-600 focus:text-red-600 focus:bg-red-50 py-2.5 cursor-pointer"
              data-testid={`delete-folder-${folder.id}`}
            >
              <Trash2 className="w-4 h-4 mr-2" />
              Excluir
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
        )}
      </TableCell>
    </TableRow>
  );
}
